module.exports = __webpack_public_path__ + "static/media/header_registration.b4efd56e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_registration.jpg
// module id = 1094
// module chunks = 0